import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';
import { formatViews } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
  showCategory?: boolean;
}

export default function ComicCard({ comic, size = 'medium', showCategory = true }: ComicCardProps) {
  const coverHeight = size === 'small' ? 'h-52' : size === 'large' ? 'h-72' : 'h-60';
  const titleSize = size === 'small' ? 'text-sm' : 'text-base';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className={`relative ${coverHeight} rounded-lg overflow-hidden bg-background-200`}>
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 布丁漫画韩国漫画`}
          title={`${comic.title} - 布丁漫画免费在线韩国漫画阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {showCategory && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
            {comic.category}
          </span>
        )}

        {comic.status === '已完结' && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-background-950/70 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
            {comic.status}
          </span>
        )}

        {comic.isHot && (
          <span className="absolute bottom-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
            <i className="ri-fire-line mr-0.5"></i>热门
          </span>
        )}
      </div>

      <div className="mt-2.5">
        <h3 className={`${titleSize} font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1`}>
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500 flex items-center gap-0.5">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            {comic.rating}
          </span>
        </div>
        <div className="flex items-center gap-2 mt-0.5">
          <span className="text-xs text-foreground-500">
            <i className="ri-eye-line mr-0.5"></i>
            {formatViews(comic.views)}
          </span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">
            更新至{comic.chapters.length}话
          </span>
        </div>
      </div>
    </Link>
  );
}